import { useComputedColorScheme } from '@mantine/core';
import type { StyleSpecification } from 'maplibre-gl';

import { useGeoMarkupStore } from '../store';
import { selectResolvedBasemapId } from '../store/selectors';
import { resolveBasemapStyle } from '../config/maplibre';

/**
 * Whether the resolved basemap is dark (CARTO Dark Matter).
 * Use for adapting overlay layer colors (borders, roads) to the basemap.
 */
export function useIsDarkBasemap(): boolean {
  const basemapId = useGeoMarkupStore(selectResolvedBasemapId);
  const colorScheme = useComputedColorScheme('light');
  return (
    basemapId === 'carto-dark' ||
    (basemapId === 'auto' && colorScheme === 'dark')
  );
}

/**
 * Returns the resolved 2D basemap style based on the user's basemap
 * preference and the current color scheme (for 'auto' mode).
 *
 * Does NOT handle 3D terrain — use useTerrainMode for that.
 */
export function useBasemapStyle(): StyleSpecification | string {
  const basemapId = useGeoMarkupStore(selectResolvedBasemapId);
  const colorScheme = useComputedColorScheme('light');

  return resolveBasemapStyle(basemapId, colorScheme);
}
